import { useCallback, useState } from 'react';

import type { ProductListProduct } from '../components/types';

export const useArticles = (initialArticles: ProductListProduct[]) => {
  const [articles, setArticles] = useState(initialArticles);

  const prependArticles = useCallback(
    (newArticles: ProductListProduct[]) => setArticles(prev => [...newArticles, ...prev]),
    []
  );

  const appendArticles = useCallback(
    (newArticles: ProductListProduct[]) => setArticles(prev => [...prev, ...newArticles]),
    []
  );

  return {
    prependArticles,
    appendArticles,
    articles,
  };
};
